import { Navigate } from 'react-router-dom';
import { EMPLOYER_BASE_PATH } from '@/utils/employer/constants';

export default function Page() {
  return <Navigate to={`${EMPLOYER_BASE_PATH}/home`} />;
}
